/**
 * Labstep
 *
 * @module components/Metadata/Detail/Table/Value
 * @desc Table for metadata detail
 */

import { EntityDetailTable } from 'labstep-web/components/Entity/Detail/Table';
import type React from 'react';
import type { MetadataDetailTableValueProps } from './types';
import { getRows } from './utils';

export const MetadataDetailTableValue: React.FC<
  MetadataDetailTableValueProps
> = ({ metadata, entity }) => (
  <EntityDetailTable rows={getRows(entity)} columns={[metadata]} />
);
